import React, { useState, useEffect } from "react";
import {
    Grid,
    Tab,
    Tabs,
} from "@material-ui/core";
import useStyles from "./styles";
import Loader from "../../components/Loader/Loader";
import Breadcrums from "../../components/BreadCrums/breadcrums";
import { withSnackbar } from "./../../components/Message/Alert";
import TopSpacer from '../../components/Common/spacer/TopSpacer';
import AgencyList from "./components/agencyList/AgencyList";
import DistributerList from "./components/distributerList/DistributerList";
import LetterOfSupportTab from "./components/letterOfSupportTab/LetterOfSupportTab";
import { GetUserRolesRights } from '../../Services/GetUserRolesRights';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <>{children}</>
            )}
        </div>
    );
}
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


function LetterOfSupport({ isPostpaid, isPinCodeVerified, ...props }) {
    const classes = useStyles();
    const [state, setState] = useState({ accounts: "" });
    const [isLoading, setIsLoading] = useState(false);

    const [tabvalue, setTabValue] = useState(null);

    const onTabChange = (e, newValue) => {
        setTabValue(newValue);
    };


    let user_role_rights_list = JSON.parse(GetUserRolesRights());

    const hasAgencyListRight = user_role_rights_list.some(item => item.rightCode === "Los_AgencyList" && item.permissionCode === 2);
    const hasDistributerList = user_role_rights_list.some(item => item.rightCode === "Los_DistributerList" && item.permissionCode === 2);
    const hasLetterofSupport = user_role_rights_list.some(item => item.rightCode === "Los_LetterofSupportList" && item.permissionCode === 2);

    const agencyMenuLabel = user_role_rights_list.filter(item => item.rightCode === "Los_AgencyList")[0].rightLabel;
    const distributerMenuLabel = user_role_rights_list.filter(item => item.rightCode === "Los_DistributerList")[0].rightLabel;
    const lOSMenuLabel = user_role_rights_list.filter(item => item.rightCode === "Los_LetterofSupportList")[0].rightLabel;
    useEffect(() => {
        if (hasAgencyListRight) {
            setTabValue(agencyMenuLabel);
        } else if (hasDistributerList) {
            setTabValue(distributerMenuLabel);
        } else if (hasLetterofSupport) {
            setTabValue(lOSMenuLabel);
        }
    }, []);

    return (
        <>
            {isLoading ? <Loader></Loader> : ''}
            <TopSpacer></TopSpacer>

            <div className={classes.header}>

                <Grid container alignItems="baseline">
                    <Grid item lg={12}>

                        <Breadcrums parentLink={"Letter of Support"} currentLink={tabvalue} isBack={false}></Breadcrums>
                    </Grid>
                </Grid>
            </div>
            <div className={classes.tabarea}>
                <div className={classes.tabPan}>
                    <div className={classes.tabsSection}>
                        <Tabs

                            value={tabvalue}
                            onChange={onTabChange}
                            aria-label="icon tabs example"
                            variant="scrollable"
                            scrollButtons={true}
                            className={classes.Htabs}
                            allowScrollButtonsMobile
                        >

                            {hasAgencyListRight && (<Tab label={agencyMenuLabel} value={agencyMenuLabel} aria-label={agencyMenuLabel} {...a11yProps(0)} />)}
                            {hasDistributerList && (<Tab label={distributerMenuLabel} value={distributerMenuLabel} aria-label={distributerMenuLabel} {...a11yProps(1)} />)}
                            {hasLetterofSupport && (<Tab label={lOSMenuLabel} value={lOSMenuLabel} aria-label={lOSMenuLabel} {...a11yProps(2)} />)}


                        </Tabs>
                    </div>
                </div>
                {hasAgencyListRight && (<TabPanel value={tabvalue} index={agencyMenuLabel} className={classes.tabPan}>
                    {tabvalue === agencyMenuLabel ?
                        <AgencyList></AgencyList>
                        : null}
                </TabPanel>)}


                {hasDistributerList && (<TabPanel value={tabvalue} index={distributerMenuLabel} className={classes.tabPan}>
                    {tabvalue === distributerMenuLabel ?
                        <DistributerList></DistributerList>

                        : null}

                </TabPanel>)}
                {hasLetterofSupport && (<TabPanel value={tabvalue} index={lOSMenuLabel} className={classes.tabPan}>
                    {tabvalue === lOSMenuLabel ?
                        <LetterOfSupportTab></LetterOfSupportTab>

                        : null}

                </TabPanel>)}

            </div>


        </>
    )
}
export default withSnackbar(LetterOfSupport);
